import { readIsClinicAdmin } from "~/services/readIsClinicAdmin";

export default async function ({ app, store, redirect, route }) {
  if (!store.getters["auth/isLoggedIn"]) {
    redirect({ path: "/admin/login", query: { from: route.path } });
  } else {
    const isAdmin: boolean = await readIsClinicAdmin(
      store.getters["auth/getUserId"]
    );
    if (!isAdmin) {
      alert(app.i18n.t("middleware.pleaseUseAdminAccount"));
      await store.dispatch("auth/logout");
      redirect({
        path: app.localePath("/admin/login"),
        query: { from: route.path },
      });
    }
  }
}
